/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasDocumentListViewProps } from './lobas-document-list';

export default (props: ILobasDocumentListViewProps) => {
    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {props.lobasDocumentListContainer}
        </div>
    );
};
